<template>
  <div id="boothLog">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'boothLog'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/exhibition/log/booth/BoothLog.vue